import { ReactNode } from 'react';

interface ClubListProps {
  children: ReactNode;
}

function ClubList({ children }: ClubListProps) {
  return <div className='ClubList'>{children}</div>;
}

export default ClubList;
